import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

export const getTimeZones = async () =>
  get('/bets/timezone/').then(camelizeKeys);
